import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import { TrackedArray } from 'tracked-built-ins';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class UiFormFieldStringArrayComponent extends Component {
  get entries() {
    return this.args.value ?? new TrackedArray([]);
  }

  addEntry = () => {
    this.entries.push('');

    this.args.onChange(this.entries);
  };

  removeEntry = (index) => {
    this.entries.splice(index, 1);

    this.args.onChange(this.entries);
  };

  updateEntry = (index, e) => {
    this.entries[index] = e.target.value;

    this.args.onChange(this.entries);
  };

  <template>
    <div class={{(bem)}}>
      {{#each this.entries key='@index' as |entry index|}}
        <div class={{bem 'entry'}}>
          <input
            value={{entry}}
            name={{index}}
            class={{bem 'input'}}
            aria-label={{t 'ui.form.field.string_array.edit_entry'}}
            placeholder={{@placeholder}}
            disabled={{@isDisabled}}
            {{on 'change' (fn this.updateEntry index)}}
          />
          <Button
            @disabled={{@isDisabled}}
            @style='outline'
            @icon='delete'
            @iconClass='u-color-error'
            class={{bem 'remove'}}
            aria-label={{t 'ui.form.field.string_array.remove_entry'}}
            {{on 'click' (fn this.removeEntry index)}}
          />
        </div>
      {{/each}}

      <Button
        @label={{t 'ui.form.field.string_array.add_entry'}}
        @icon='add'
        @style='outline'
        @disabled={{@isDisabled}}
        {{on 'click' this.addEntry}}
      />
    </div>
  </template>
}
